import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about page-transition">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1>About ProsperityPartners</h1>
            <p>Your trusted partner in business growth and strategic success</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section mission">
        <div className="container">
          <div className="grid grid-2">
            <div className="mission-content">
              <h2>Our Mission</h2>
              <p>
                At ProsperityPartners, we are dedicated to helping businesses achieve sustainable growth 
                through strategic consulting and expert guidance. Our mission is to empower companies 
                with the knowledge, tools, and strategies they need to thrive in today's competitive market.
              </p>
              <p>
                We believe that every business has the potential for greatness, and our role is to unlock 
                that potential through personalized consulting services that address your unique challenges 
                and opportunities.
              </p>
            </div>
            <div className="mission-image">
              <div className="image-placeholder">
                <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section values">
        <div className="container">
          <div className="section-header text-center">
            <h2>Our Core Values</h2>
            <p>The principles that guide everything we do</p>
          </div>
          
          <div className="grid grid-3">
            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                </svg>
              </div>
              <h3>Excellence</h3>
              <p>We strive for excellence in everything we do, delivering the highest quality consulting services to our clients.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"></path>
                  <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
              </div>
              <h3>Integrity</h3>
              <p>We conduct our business with the highest ethical standards, building trust through transparency and honesty.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3>Partnership</h3>
              <p>We believe in building long-term partnerships with our clients, working together to achieve shared success.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section team">
        <div className="container">
          <div className="section-header text-center">
            <h2>Our Team</h2>
            <p>Prosperity Partners is a Toronto-based consulting agency dedicated to helping businesses grow and succeed. Our team of experts will be introduced soon.</p>
          </div>
          {/* Team members will be added here in the future */}
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Work Together?</h2>
            <p>Let's discuss how we can help transform your business and drive sustainable growth.</p>
            <Link to="/contact#book-appointment-form" className="btn btn-primary btn-large">
              Book Your Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 